import './RadioItem.css';

import { IonItem, IonRadio, IonText } from '@ionic/react';

interface Props {
    value: string,
    label: string,
    isChecked?: boolean,
    disabled?: boolean
    change?: any,
    focus?: any
}

const RadioItem: React.FC<Props> = (props) => {
    return (
        <IonItem className="radio" lines="none">
            <IonText>{props.label}</IonText>
            {props.disabled ?
                <IonRadio slot="start" disabled />
                : <IonRadio value={props.value} onIonFocus={props.focus} slot="start" />}
        </IonItem>
    )
}

export default RadioItem